import { CreateDocumentType, CustomerKYCDocument } from './../models/documents';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocumentDetail } from '../models/documents';
import { Observable } from 'rxjs';
import {
    CustomerProfile,
    DocumentTypeSummary,
    DriverProfile,
    KYCDocument,
    VehicleProfile,
} from '../models/common-data-types';
import { ApproveKYCDocumentPayload } from '../models/approve-document';
import { DocumentEntities } from '../constants/document-entities';

@Injectable({
    providedIn: 'root',
})
export class DocumentsService {
    constructor(private http: HttpClient) {}

    fetchDocuments(): Observable<DocumentTypeSummary[]> {
        return this.http.get<DocumentTypeSummary[]>('/admin/document-types');
    }

    createDocumentType(
        payload: CreateDocumentType
    ): Observable<DocumentTypeSummary> {
        return this.http.post<DocumentTypeSummary>(
            '/admin/document-types',
            payload
        );
    }

    fetchCustomerDocuments(id: string): Observable<CustomerKYCDocument[]> {
        return this.http.get<CustomerKYCDocument[]>(
            '/admin/documents?ownerId=' + id
        );
    }

    getDocumentById(id: string): Observable<any> {
        return this.http.get('/admin/documents/' + id + '/download', {
            observe: 'response',
            responseType: 'blob',
        });
    }

    approveCustomerDocument(
        payload: ApproveKYCDocumentPayload,
        customerId: string,
        documentId: string,
        entityId: string,
        documentEntity: DocumentEntities
    ): Observable<DriverProfile | VehicleProfile | CustomerProfile> {

        if (documentEntity === DocumentEntities.DRIVER) {
            return this.http.post<DriverProfile>(
                '/admin/customers/' +
                    customerId +
                    '/drivers/' +
                    entityId +
                    '/documents/' +
                    documentId +
                    '/verification',
                payload
            );
        } else if (documentEntity === DocumentEntities.VEHICLE) {
            return this.http.post<DriverProfile>(
                '/admin/customers/' +
                    customerId +
                    '/vehicles/' +
                    entityId +
                    '/documents/' +
                    documentId +
                    '/verification',
                payload
            );
        } else {
            return this.http.post<DriverProfile>(
                '/admin/customers/' +
                    customerId +
                    '/documents/' +
                    documentId +
                    '/verification',
                payload
            );
        }
    }
}
